import React, { FC } from 'react';
import { Box } from '@mui/material';
import { CustomerType, LabClient } from 'models/client-directory';
import ConnectedClientContact from './connected-client-contact/connected-client-contact.component';
import OwnClientContact from './own-client-contact/own-client-contact.component';

type ClientContactDetailsProps = {
    labClient: LabClient;
    onContactSaved?: () => void;
};
const ClientContactDetails: FC<ClientContactDetailsProps> = ({
    labClient,
    onContactSaved,
}: ClientContactDetailsProps) => {
    return (
        <Box mt={3}>
            {labClient?.customer?.customerType === CustomerType.DENTHUB_CONNECTED ||
            labClient?.customer?.customerType === CustomerType.SUPPLIER ? (
                <ConnectedClientContact labClient={labClient} onContactSaved={onContactSaved} />
            ) : undefined}

            {labClient?.customer?.customerType === CustomerType.MY_CLIENT ? (
                <OwnClientContact labClient={labClient} onContactSaved={onContactSaved} />
            ) : undefined}
        </Box>
    );
};

export default ClientContactDetails;
